import React, { useEffect, useState } from 'react'
import { useAsyncCallback } from 'react-async-hook'
import { useSelector } from 'react-redux'

import { Button, PageLoader } from 'component-library-next'

import { FormattedError } from '@app/common/Components/FormattedError'
import { sendGTMEvent } from '@app/common/helpers/analyticsHelperFunctions'
import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { AuthSelectors } from '@app/modules/Auth'
import { useSendUpgradeRecommendationMutation } from '@app/queries/SendUpgradeRecommendation/SendUpgradeRecommendation.queries'

import './style.scss'

export type Props = {
  customerId: number
  upgradesTo?: number[] | null
}

export function RecommendUpgradeButton({ customerId, upgradesTo }: Props) {
  const [upgradeRequested, setUpgradeRequested] = useState<boolean>(false)
  const lawyerId = useSelector(AuthSelectors.getUserId)
  const { pushNotification } = useNotifications()

  useEffect(() => setUpgradeRequested(false), [customerId])

  const [sendProductUpgradeRecommendation] = useSendUpgradeRecommendationMutation({
    onError: (error) => {
      pushNotification({
        type: AlertType.error,
        message: <FormattedError error={error} />
      })
    }
  })

  const sendProductUpgradeRecommendationEmail = useAsyncCallback(async () => {
    upgradesTo &&
      (await sendProductUpgradeRecommendation({
        variables: {
          input: {
            customerId,
            lawyerId,
            productId: upgradesTo[0]
          }
        }
      }))

    setUpgradeRequested(true)

    sendGTMEvent({
      event: 'gaEvent',
      eventCategory: 'New Schreiben Empfehlen Event',
      eventAction: 'click CTA Schreiben empfehlen',
      eventLabel: lawyerId
    })
  })

  if (upgradeRequested || !upgradesTo || upgradesTo.length === 0) {
    return null
  }

  if (sendProductUpgradeRecommendationEmail.loading) {
    return <PageLoader loading />
  }

  return (
    <div className='request-upgrade__button'>
      <Button
        size={Button.sizes.medium}
        onClick={sendProductUpgradeRecommendationEmail.execute}
        color={Button.colors.premium}
      >
        Schreiben empfehlen
      </Button>
    </div>
  )
}
